export const tags = { Todos: 'todos', Calendars: 'calendars' };
